import { Modal } from '@/hooks/useModals'
import { atom } from 'recoil'

export const modalsState = atom<Modal[]>({
  key: 'modalsState',
  default: [],
})
